module.exports = __webpack_public_path__ + "static/media/IMG_8035.d32e4200.jpg";